import { NoteItemFragment } from "@/gql/graphql";

enum Ord {
  GT = 1,
  LT = -1,
  EQ = 0,
}

export function compareNoteDate(a: NoteItemFragment, b: NoteItemFragment): Ord {
  if (a.date && b.date) {
    const aTimestamp = new Date(a.date).getTime();
    const bTimestamp = new Date(b.date).getTime();

    if (aTimestamp < bTimestamp) return Ord.GT;
    if (aTimestamp > bTimestamp) return Ord.LT;
  }

  return Ord.EQ;
}
